import { useTranslation } from '@frontend/i18n';
import { InboxLocationPhones } from '@frontend/inbox-location-phones';
import { usePopoverMenu } from '@frontend/design-system';
import { InboxFiltersPopoverSubmenuItem } from '../inbox-filters-popover-submenu-item';
import { LocationPhonesFilterPopoverMenu } from './location-phones-filter-popover';

type LocationPhonesFilterPopoverSubmenuItemProps = {
  toggleItems: (departmentIds: string[]) => void;
  selectedLocationPhones: string[];
  divider?: 'top' | 'bottom';
  trackingId?: string;
};

export const LocationPhonesFilterPopoverSubmenuItem = ({
  toggleItems,
  selectedLocationPhones,
  divider,
  trackingId,
}: LocationPhonesFilterPopoverSubmenuItemProps) => {
  const { t } = useTranslation('inbox');
  const locationPhonesPopover = usePopoverMenu<HTMLButtonElement>({
    placement: 'right-start',
    middlewareOptions: {
      offset: {
        mainAxis: 0,
        crossAxis: -8,
      },
    },
  });

  const {
    data: { allLocationPhones },
  } = InboxLocationPhones.Hooks.useLocationPhones();

  if (allLocationPhones.length < 2) return null;

  return (
    <>
      <InboxFiltersPopoverSubmenuItem
        getSubmenuTriggerProps={locationPhonesPopover.getTriggerProps}
        iconName='fax-number'
        label={t('Phone Numbers')}
        count={selectedLocationPhones.length}
        divider={divider}
        trackingId={trackingId}
      />
      <LocationPhonesFilterPopoverMenu
        getMenuProps={locationPhonesPopover.getMenuProps}
        getItemProps={locationPhonesPopover.getItemProps}
        toggleItems={toggleItems}
        selectedLocationPhones={selectedLocationPhones}
      />
    </>
  );
};
